import React, { useState } from 'react';
import { PaymentMethod } from '../components/PaymentButton';

const usePaymentState = (
  setIsENetsModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsQRPaymentModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsPaymentModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsBankTransferModalOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [internalTransactionRef, setInternalTransactionRef] = useState('');

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<PaymentMethod | null>(null);
  const [isDisabled, setIsDisabled] = useState(false);
  // get a reference to opened enets window, so can refocus to that window if it exists

  const [pollingEnabled, setPollingEnabled] = useState(false);

  const paymentModalOnClose = (paymentMethod: PaymentMethod) => {
    if (paymentMethod === PaymentMethod.ENETS_CREDIT_CARD) {
      setIsENetsModalOpen(false);
      setInternalTransactionRef('');
    } else if (paymentMethod === PaymentMethod.PAYNOW_QR) {
      setIsQRPaymentModalOpen(false);
      setPollingEnabled(false);
    } else if (paymentMethod === PaymentMethod.BANK_TRANSFER) {
      setIsBankTransferModalOpen(false);
    }
    setIsDisabled(false);
    setIsPaymentModalOpen(true);
    setSelectedPaymentMethod(null);
  };

  return {
    internalTransactionRef,
    selectedPaymentMethod,
    isDisabled,
    pollingEnabled,
    setInternalTransactionRef,
    setSelectedPaymentMethod,
    setIsDisabled,
    setPollingEnabled,
    paymentModalOnClose,
  };
};

export { usePaymentState };
